import { EmployeeCostCenterResponse, EmployeeCostCenterResponseItem } from '@/types/service-response'

export class EmployeeCostCenter {
  private constructor (
    readonly code: string,
    readonly title: string,
    readonly assigned: boolean
  ) {}

  public static createFromResponse (data: EmployeeCostCenterResponse): Array<EmployeeCostCenter> {
    let result: Array<EmployeeCostCenter> = []

    data.forEach((item: EmployeeCostCenterResponseItem) => {
      result.push(new EmployeeCostCenter(item.Nummer, item.Bezeichnung, item.MitabeiterKostenstelle))
    })

    return result
  }

}